import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class StudyDatasetContext {

    private createLotsSubject = new Subject<void>();
    private plantingInventorySubject = new Subject<void>();
    private changePlotEntrySubject = new Subject<void>();

    get createLots$() {
        return this.createLotsSubject.asObservable();
    }

    get plantingInventory$() {
        return this.plantingInventorySubject.asObservable();
    }

    get changePlotEntry$() {
        return this.changePlotEntrySubject.asObservable();
    }

    triggerCreateLots() {
        this.createLotsSubject.next();
    }

    triggerPlantingInventory() {
        this.plantingInventorySubject.next();
    }

    triggerChangePlotEntry() {
        this.changePlotEntrySubject.next();
    }

}
